var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRender)?_c('BaseButton',{attrs:{"href":_vm.link,"icon":"edit","size":"medium","tag":"a","target":"_blank","theme":"blue"}},[_vm._v("\n  Редактировать\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }